import { Link } from 'react-router-dom';
import { featuredMatches } from '@/mocks/categories';

export default function MatchesSection() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门赛事
            </h2>
            <p className="text-sm text-foreground-600 mt-1">实时赔率 · 专业竞猜</p>
          </div>
          <Link
            to="/category/football"
            className="hidden sm:flex items-center gap-1 text-sm text-accent-700 hover:text-accent-800 transition-colors duration-200 font-medium"
          >
            查看全部赛事
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {featuredMatches.slice(0, 6).map((match) => (
            <Link
              key={match.id}
              to={`/category/${match.category}`}
              className="group block bg-background-100 rounded-lg p-5 hover:bg-background-200/70 transition-all duration-300 border border-background-200/60"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-medium text-accent-700 bg-accent-100 px-2.5 py-1 rounded-full">
                  {match.league}
                </span>
                <span className="text-xs text-foreground-500">{match.time}</span>
              </div>

              <div className="flex items-center justify-between gap-4">
                <div className="flex flex-col items-center flex-1">
                  <div className="w-10 h-10 flex items-center justify-center bg-background-200 rounded-full mb-1.5 group-hover:bg-accent-100 transition-colors duration-300">
                    <i className={`${match.homeIcon} text-foreground-700 text-lg`}></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-900 text-center leading-tight">
                    {match.home}
                  </span>
                </div>

                <div className="flex flex-col items-center">
                  <span className="text-xs text-foreground-500 font-medium">VS</span>
                </div>

                <div className="flex flex-col items-center flex-1">
                  <div className="w-10 h-10 flex items-center justify-center bg-background-200 rounded-full mb-1.5 group-hover:bg-accent-100 transition-colors duration-300">
                    <i className={`${match.awayIcon} text-foreground-700 text-lg`}></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-900 text-center leading-tight">
                    {match.away}
                  </span>
                </div>
              </div>

              {'draw' in match.odds ? (
                <div className="flex items-center gap-2 mt-4 pt-3 border-t border-background-200/60">
                  <div className="flex-1 text-center">
                    <span className="block text-xs text-foreground-500">主胜</span>
                    <span className="text-sm font-bold text-accent-700">{match.odds.home}</span>
                  </div>
                  <div className="flex-1 text-center">
                    <span className="block text-xs text-foreground-500">平局</span>
                    <span className="text-sm font-bold text-foreground-700">{match.odds.draw}</span>
                  </div>
                  <div className="flex-1 text-center">
                    <span className="block text-xs text-foreground-500">客胜</span>
                    <span className="text-sm font-bold text-foreground-700">{match.odds.away}</span>
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-2 mt-4 pt-3 border-t border-background-200/60">
                  <div className="flex-1 text-center">
                    <span className="block text-xs text-foreground-500">主胜</span>
                    <span className="text-sm font-bold text-accent-700">{match.odds.home}</span>
                  </div>
                  <div className="flex-1 text-center">
                    <span className="block text-xs text-foreground-500">客胜</span>
                    <span className="text-sm font-bold text-foreground-700">{match.odds.away}</span>
                  </div>
                </div>
              )}
            </Link>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-6">
          <Link
            to="/category/football"
            className="flex items-center gap-1 text-sm text-accent-700 hover:text-accent-800 transition-colors duration-200 font-medium"
          >
            查看全部赛事
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}